type Props = {
  x: number;
  y: number;
  width: number;
  height: number;
  fillColor: number;
  rotation?: number;
  pivotX?: number;
  pivotY?: number;
  opacity?: number;
};

const Box = ({
  x,
  y,
  width,
  height,
  fillColor,
  rotation = 0,
  pivotX = 0,
  pivotY = 0,
  opacity = 1,
}: Props) => (
  <box
    x={x}
    y={y}
    width={width}
    height={height}
    fillColor={fillColor}
    rotation={rotation}
    pivotX={pivotX}
    pivotY={pivotY}
    opacity={opacity}
  />
);

export default Box;
